<template>
  <div v-if="product">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售订单</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="订单详情">
      </el-page-header>
      <el-descriptions title="" size="small">
        <el-descriptions-item label="单号">{{
          product.number
        }}</el-descriptions-item>
        <el-descriptions-item label="销售">
          {{ product.saler }}
        </el-descriptions-item>
        <el-descriptions-item label="客户">
          {{ product.customer_name }}
        </el-descriptions-item>
        <el-descriptions-item label="客户联系人">
          {{ product.customer_contact
          }}{{
            product.customer_contact_phone
              ? '（' + product.customer_contact_phone + '）'
              : ''
          }}
        </el-descriptions-item>
        <el-descriptions-item label="销售钻头">
          <DrillLink :no="item" v-for="item in product.drill_ids" :key="item">{{
            item
          }}</DrillLink>
        </el-descriptions-item>
        <el-descriptions-item label="订单金额">
          {{ product.total_price.toFixed(2) }}
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ product.remark }}
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{
          $time(product.created_at).format('YYYY-MM-DD HH:mm')
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag size="mini" type="primary">{{
            SaleOrderStatusMap[product.status]
          }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="物流信息" v-if="product.logistic_number">
          {{ product.logistic_number }}（{{ product.logistic_company_name }}）
        </el-descriptions-item>
        <el-descriptions-item label="发票" v-if="product.status == 100">
          <el-link
            :href="product.receipt.path"
            target="_blank"
            type="primary"
            class="font-12"
            :underline="false"
            >{{ product.receipt.name }}</el-link
          >
        </el-descriptions-item>
      </el-descriptions>
      <el-button
        v-code="81103"
        type="primary"
        size="mini"
        plain
        @click="editProduct"
        v-if="product.status == 1"
        >编辑</el-button
      >
      <el-button
        v-code="81106"
        v-if="product.status == 1"
        @click="showOptionFomer"
        type="primary"
        size="mini"
        class="ml-10"
        plain
        >发货</el-button
      >
      <el-button
        v-code="81107"
        type="primary"
        size="mini"
        plain
        v-if="product.status == 2"
        @click="showOptionFomer"
        >上传发票</el-button
      >
    </div>
    <EditFormer
      :model="model"
      :show.sync="formerVisible"
      @callback="updatedCallback"
    ></EditFormer>

    <OptionFormer
      :model="opitonModel"
      :show.sync="optionFormerVisible"
      @callback="updatedCallback"
    ></OptionFormer>
  </div>
</template>

<script>
import { saleOrderDetail } from '@/service/getData'
import EditFormer from './editor'
import { SaleOrderStatusMap } from '../../../config/global'
import OptionFormer from './optionFormer.vue'

export default {
  components: {
    EditFormer,
    OptionFormer,
  },
  data() {
    return {
      SaleOrderStatusMap,
      product: null,
      formerVisible: false,
      model: {},
      optionFormerVisible: false,
      opitonModel: {},
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await saleOrderDetail(this.$route.params.id)
      if (res.status == 0) {
        this.product = res.data
      }
    },
    editProduct() {
      this.model = this.clone(this.product)
      this.formerVisible = true
    },
    updatedCallback() {
      this.getData()
    },
    showOptionFomer() {
      this.opitonModel = {
        id: this.product.id,
        status: this.product.status,
        logistic_company: '',
        logistic_number: '',
        imgs: [],
      }
      this.optionFormerVisible = true
    },
  },
}
</script>